export const configData = {
    // base_url: "http://localhost:5000",
    base_url: "https://api.rupira.com",
    // mqtt_url: "ws://localhost:1883",
    mqtt_url: "wss://mqtt.rupira.com:8083",
};